import { render } from "./clinic-list.vue?vue&type=template&id=bdd17a64&scoped=true"
import script from "./clinic-list.vue?vue&type=script&lang=js"
export * from "./clinic-list.vue?vue&type=script&lang=js"

import "./clinic-list.vue?vue&type=style&index=0&id=bdd17a64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd17a64"]])

export default __exports__